import React from "react";

const NotificationBanner = ({ icon, message }) => {
  return (
    <div
      style={{
        margin:"10px 0px",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#266EF1",
        color: "white",
        padding: "12px 16px",
        borderRadius: "12px",
        width: "100%",
      }}
    >
      <img
        src={icon}
        alt="Info"
        style={{
          width: "20px",
          height: "20px",
          marginRight: "8px",
        }}
      />

      <span style={{ fontSize: "12px" }}>{message}</span>
    </div>
  );
};

export default NotificationBanner;
